const isAorAn = (text: string) => {
  if (!text) {
    return '';
  }

  const vowels = ['a', 'e', 'i', 'o', 'u'];
  const firstLetter = text.charAt(0).toLowerCase();

  return vowels.includes(firstLetter) ? 'an' : 'a';
};

export default isAorAn;
